import {Component, OnInit, Output, Input, EventEmitter} from '@angular/core';
import {UserService} from '../user/user-service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
    selector: 'dk-popup',
    template: require('./generic_popup.html'),
    providers: [ UserService ],
    styleUrls: [ 'web/bootstrap.min.css' ] 
})

export class ModalMessageComponent implements OnInit{
    @Input() id: string;
    @Input() title: string;
    @Input() content: string;
    @Output() closeModalEvent = new EventEmitter<boolean>();


    constructor(public activeModal: NgbActiveModal, private userService: UserService) { }
    
    ngOnInit() {  }
    
    accept(): void {
        this.sendResponse();
    }

    private sendResponse(){
        this.userService.readMessage(this.id).subscribe(result => {
            this.activeModal.close();
        });
    }

    close() {
        this.activeModal.close();
    }

  }
